import EmbedWizardApp from "embedshowswizard/app";
import { type RouteObject } from "react-router";

declare let viewModel: any;

export const wizardEmbedShowRoute: RouteObject = {
  path: "wizard",
  children: [{
    path : "embedshow",
    loader: () => viewModel,
    Component: EmbedWizardApp,
  }]
};